import { make } from 'vuex-pathify';
import { FinancialReportTypesService } from '../services/financial-report-types.service.js';
import Logger from '@/lib/logger.js';

const service = new FinancialReportTypesService();

const state = {
  financialReportTypes: []
};

const mutations = make.mutations(state);

const actions = {
  async createFinancialReportType({ dispatch }, payload) {
    try {
      const data = await service.createFinancialReportType(payload);
      dispatch('fetchFinancialReportTypes')
      return data
    } catch (error) {
      console.log(error);
      Logger.error('Creating Financial Report Type') 
      throw(error)
    }
  },

  async fetchFinancialReportTypes({ commit }) {
    try {
      const {data} = await service.fetchFinancialReportTypes();
      commit('SET_FINANCIAL_REPORT_TYPES', data);
      return data
    } catch (error) {
      console.log(error);
      Logger.error('Fetching Financial Report Type') 
      throw(error)
    }
  },

  async updateFinancialReportType({ dispatch }, {id, updates}) {
    try {
      console.log(id);
      const data = await service.updateFinancialReportType(id, updates);
      console.log({id, updates});
      dispatch('fetchFinancialReportTypes')
      return data
    } catch (error) {
      console.log(error);
      Logger.error('Updating Financial Report Type')
      throw(error)
    }
  },

  async deleteFinancialReportType({ dispatch }, id) {
    try {
      const data = await service.deleteFinancialReportType(id);
      dispatch('fetchFinancialReportTypes')
      return data
    } catch (error) {
      console.log(error);
      Logger.error('Deleting Financial Report Type') 
      throw(error)
    }
  }

};

export default {
  state,
  mutations,
  actions
};